import { jsxs as r, jsx as l } from "react/jsx-runtime";
const t = (o) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M25.216 27.236v14.297l4.521-1.212 3.047 8.957 6.031-19.129-4.504 1.207v-6.661l-9.095 2.539v.002Zm9.612 6.051.987-.265-3.103 9.841-1.084-3.185-.602-1.77-1.806.485-2.006.537V28.753l5.099-1.423v6.632l2.515-.674h-.001l.001-.001Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M57.985 52.934V20.007l-26-14-26 14v34a4 4 0 0 0 4 4h45.072l-1.072-4h-44V22.396l22-11.846 22 11.846v31.609l4-1.072v.001Z"
        }
      )
    ]
  }
);
export {
  t as PayAsYouGo
};
